// extracted by mini-css-extract-plugin
export default {"accessDataContainer":"AccessDataPage_accessDataContainer__wZPI4"};